import { useContext, useMemo } from "react";
import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import DepartmentIdentityContext from "src/contexts/data/DepartmentIdentityContext";
import InstitutionIdentityContext from "src/contexts/data/InstitutionIdentityContext";
import { createDepartmentSubMenu } from "src/routing/navigation";

const DepartmentSubMenu: React.FC = () => {
    const { data: institutionIdentity } = useContext(InstitutionIdentityContext);
    const { data: departmentIdentity } = useContext(DepartmentIdentityContext);

    const subMenu = useMemo(() => {
        if (!institutionIdentity || !departmentIdentity) {
            return null;
        }

        return createDepartmentSubMenu(institutionIdentity, departmentIdentity);
    }, [departmentIdentity, institutionIdentity]);

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default DepartmentSubMenu;
